import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import styles from "../ItemsBlock/ItemsBlock.module.scss";
import { showTitleWithDots } from "../utils";

const Items = ({ list, handleLinkClick }) => {
  return (
    <>
      {list.map(item => (
        <span
          key={item.id}
          role="button"
          tabIndex="0"
          className={cn(styles.item)}
          onClick={e => handleLinkClick(e, item.url, item.target, item.isInternalLink)}
          onMouseEnter={e => showTitleWithDots(e, item.title, true)}
        >
          <span>{item.title}</span>
        </span>
      ))}
    </>
  );
};

Items.propTypes = {
  list: PropTypes.array.isRequired,
  handleLinkClick: PropTypes.func.isRequired
};

export default Items;
